import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import img from '../../image/default/done-all-rounded.svg';
import { glb_sv } from 'src/utils';

export default function ComboboxImageNameOrQR({
    id,
    getValue,
    sizeCbb = 'small',
    valueSelect,
    label,
    required = false,
    selectOption = [],
    displayImage = 'pic_device',
    displayLabel = 'label',
    valueEqual = 'id',
    disabled = false,
    onEnterPress = () => null,
}) {
    const [value, setValue] = React.useState({});
    const inputRef = React.useRef(null);
    const handleOnChange = (event, value) => {
        setValue(value);
        getValue && getValue(value);
    };
    const handleKeyDown = (e) => {
        // Check if the pressed key is "Enter" (key code 13)
        if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
            // Call the onEnterPress function if it's provided
            // alert('ok');
            onEnterPress ? onEnterPress() : inputRef.current.blur();
        }
    };
    
    return (
        <Autocomplete
            freeSolo
            id={id}
            disabled={disabled}
            options={selectOption}
            size={sizeCbb}
            defaultValue={valueSelect ? valueSelect : value}
            value={valueSelect ? valueSelect : value}
            isOptionEqualToValue={(option, value) => option[valueEqual] === value[valueEqual]}
            autoHighlight
            onKeyDown={handleKeyDown}
            getOptionLabel={(selectOption) => (selectOption[displayLabel] ? selectOption[displayLabel] : '')}
            onChange={handleOnChange}
            filterOptions={(options, {inputValue}) => {
                return (options?.filter((option) => {
                    const device_cd = option.device_cd ? option.device_cd.toLowerCase() : '';
                    const qr_device = option.qr_device ? option.qr_device.toString() : '';
                    return device_cd.includes(inputValue.toLowerCase()) || qr_device.includes(inputValue);
                })) || [];
            }}
            renderOption={(props, option) => (
                <Box
                    component="li"
                    display={disabled ? 'none' : ''}
                    style={{ display: disabled ? 'none' : '' }}
                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                    {...props}
                >
                    <img
                        loading="lazy"
                        style={{ display: disabled ? 'none' : '' }}
                        width="40"
                        src={
                            !option['img_device'] && !option['pic_device'] 
                            ? img 
                            : (
                                option['img_device']
                                   ? `${glb_sv.urlGetProductImage(option['img_device'])}`
                                    : `${glb_sv.urlGetProductImage(option['pic_device'])}`
                            )
                        }
                        alt=""
                    />
                    {glb_sv.convertMultipleLanguages(option[displayLabel])}
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    onKeyDown={handleKeyDown}
                    label={label}
                    ref={inputRef}
                    required={required}
                    disabled={disabled}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'new-password', // disable autocomplete and autofill
                    }}
                />
            )}
        />
    );
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
